import React from 'react';
import { Link } from 'react-router-dom';
import { Plug } from 'lucide-react';
import Layout from '../components/layout/Layout.tsx';

const integrations = [
  {
    name: 'Saipos',
    slug: 'saipos',
    logo: '/saipos.png'
  },
  {
    name: 'Sischef',
    slug: 'sischef',
    logo: '/sischef.svg'
  }
];

const Integrations = () => {
  return (
    <Layout>
      <div className="min-h-full bg-[#f6f7fb] px-3 py-6 text-slate-900 sm:px-6 lg:px-8">
        <div className="mx-auto w-full max-w-[1400px] space-y-5">
          <div className="mb-1 text-center">
            <h2 className="flex items-center justify-center gap-3 text-2xl font-black text-slate-900">
              <Plug size={28} className="text-[#2f7d72]" />
              Integrações disponíveis
            </h2>
            <p className="mx-auto mt-3 max-w-3xl text-sm leading-6 text-slate-600">
              Conecte o Atendabot ao seu PDV para sincronizar pedidos automaticamente.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {integrations.map((integration) => (
              <Link
                to={`/atendabot/integrations/${integration.slug}`}
                key={integration.slug}
                className="bg-white rounded-2xl border border-slate-200 shadow-sm p-5 flex items-center space-x-4 hover:bg-gray-50"
              >
                <img
                  src={integration.logo}
                  alt={integration.name}
                  className="w-16 h-16 object-contain"
                />
                <span className="text-lg font-medium text-gray-800">
                  {integration.name}
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Integrations;
